import { saving, dialogs, integration, readOnly } from '@yola/ws-sdk';
import error from 'src/js/modules/error';
import store from 'src/js/store';
import saveSite from 'src/js/modules/saving/helpers/save-site';

const AUTO_SAVING_DELAY = 120000; // 2 minutes
let autoSavingInterval = null;

const saveWebsite = () => {
  const state = store.getState();
  const savingStatus = saving.selectors.getStatus(state);
  const currentDialog = dialogs.selectors.getDialog(state);
  const integrationSettings = integration.selectors.getSettings(state);
  const readOnlyStatus = readOnly.selectors.getReadOnlyStatus(state);
  const { isDialogVisible: isYolaDialogVisible } = integrationSettings.ui;
  const isNetworkOnline =
    error.selectors.getNetworkStatus(state) === error.constants.NETWORK_ONLINE;

  const { UNSAVED, ERROR } = saving.constants.statuses;

  const isDialogNotOpened = !currentDialog.type;
  const isSiteNotSaved = savingStatus === UNSAVED || savingStatus === ERROR;

  if (
    !readOnlyStatus &&
    isSiteNotSaved &&
    isDialogNotOpened &&
    !isYolaDialogVisible &&
    isNetworkOnline
  ) {
    saveSite();
  }
};

export const startAutoSaving = () => {
  autoSavingInterval = setInterval(saveWebsite, AUTO_SAVING_DELAY);
};

export const stopAutoSaving = () => {
  clearInterval(autoSavingInterval);
};
